<template>
    <div
        class="relative min-h-[34.884vw] overflow-hidden rounded-lg border border-grey-300 xs:min-h-[150px]"
        @click="!isReturn && handleClick(item)"
    >
        <img
            v-if="item?.label === 'hot'"
            class="absolute left-0 top-0 h-auto w-10"
            :src="`${staticUrl}/assets/icons/hot.png`"
            alt="hot icon"
        />
        <img
            v-if="item?.label === 'new'"
            class="absolute left-0 top-0 h-auto w-10"
            :src="`${staticUrl}/assets/icons/new.png`"
            alt="new icon"
        />

        <div class="absolute inset-[2px] flex items-end rounded-[8px]">
            <img
                class="absolute right-0 top-[-5px] z-10 max-h-[146px] w-[220px] max-w-full rounded-[8px] object-contain"
                :class="[
                    item.id === 'saba' || item.id === 'im-sports'
                        ? '!w-[100%]'
                        : '',
                ]"
                :src="item.image"
                :alt="item.name"
            />
            <!-- <img
                class="absolute left-[-3px] h-[100%] min-w-[338px] rounded-[8px] object-contain"
                src="/assets/icons/casino/provider/frame.png"
                :alt="item.name"
            /> -->
            <div class="absolute bottom-[18px] left-[10px] z-20 xs:left-[25px]">
                <img
                    v-if="item.icon"
                    class="h-[56px] w-[56px]"
                    :src="item.icon"
                    :alt="item.name"
                />
                <p
                    class="max-w-[130px] text-center text-[4.651vw] font-semibold uppercase xs:max-w-[150px] xs:text-xl"
                >
                    {{ item.name ? item.name : item.nameMb }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useGamesStore, useAlertStore, useFrameStore } from '~/stores'
import { QUICK_GAME } from '~/constants/apiLink'
// eslint-disable-next-line vue/require-prop-types
defineProps(['item', 'isReturn'])
const emit = defineEmits(['partner-selected'])
const alertStore = useAlertStore()
const gameStoreInstance = useGamesStore()
const { getGameUrl } = gameStoreInstance
const useFrameStoreInstance = useFrameStore()
const { getFrameUrl } = useFrameStoreInstance
const { t } = useI18n({})
const router = useRouter()

const staticUrl = useRuntimeConfig().public.staticUrl

const handleGetGameUrl = async (toSend) => {
    try {
        const { data } = await getGameUrl(toSend)
        if (data.value?.status === 'OK') {
            // TODO:handle mobile version url_mobile
            const { url } = data.value.data
            if (import.meta.client) {
                setTimeout(() => window.open(url, '_blank'))
            }
        }
    } catch (error) {
        alertStore.showMessageError(error)
    } finally {
        isLoadingGame.value = false
    }
}

const handleClick = async (item) => {
    if (item.key === 'digmaan') {
        const toSend = {
            partnerProvider: 'cockfight',
            partnerGameId: 'lobby',
        }
        await handleGetGameUrl(toSend)
        return
    }
    if (item.key === 'ibc') {
        const { data } = await getFrameUrl(QUICK_GAME)
        setTimeout(() => {
            const popup = window.open(data.value.data.url, '_blank')
            if (!popup) {
                alertStore.showMessageError({
                    value: {
                        statusCode: 'SHOW_MESSAGE',
                        message: t('error.allow_popup'),
                    },
                })
            }
        })
        return
    }
    let link = item.link
    if (item.link.includes('casino')) {
        link = '/' + link
        emit('partner-selected', item.key)
        return
    }
    if (item.link.includes('games')) {
        emit('partner-selected', item.key)
        return
    }
    // this line might not be reached, but for back compatibility left
    await router.push(link)
}
</script>
